import { fetchJobs as apiFetchJobs, fetchJobById as apiFetchJobById } from '../../../services/api';

export const fetchJobs = async () => {
  return await apiFetchJobs();
};

export const fetchJobById = async (id) => {
  try {
    const response = await apiFetchJobById(id);
    return response.data?.data || response.data || response;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch job');
  }
};
